define.alias("shared/utils/number-helpers/floor-to-significant-digits", "calendar/utils/number-helpers/floor-to-significant-digits");